var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F99A3",
    d: "M3.16 12.38a.35.35 0 0 0 .35-.35V4.213a.35.35 0 0 0-.7 0v7.819c0 .193.157.35.35.35M5.156 12.38a.35.35 0 0 0 .35-.35V4.213a.35.35 0 0 0-.7 0v7.819c0 .193.157.35.35.35M7.153 12.38a.35.35 0 0 0 .35-.35V4.213a.35.35 0 0 0-.7 0v7.819c0 .193.157.35.35.35"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .182)",
    fill: "#7F99A3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 14.444h10.473V.27H0v14.175z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.33 2.1v11.644H1.143V2.1c0-.033-.01-.064-.019-.094h8.223c-.009.03-.019.06-.019.094zM4.15.97l2.196.01.142.326H3.993L4.149.97zm5.973.336H7.252L6.896.49a.35.35 0 0 0-.319-.21L3.928.27A.361.361 0 0 0 3.61.47l-.39.835H.35a.35.35 0 0 0 0 .7h.113c-.009.03-.019.06-.019.094v11.994c0 .193.157.35.35.35H9.68a.35.35 0 0 0 .35-.35V2.1c0-.033-.01-.064-.02-.094h.114a.35.35 0 0 0 0-.7z",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionBin);
export default __webpack_public_path__ + "static/media/sectionBin.15f424f02be133873157ddb3ace64aac.svg";
export { ForwardRef as ReactComponent };